import template from './StepperModalView.html';
import controller from './StepperModalController';
export default (params) => {
    return {
        template,
        controller,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            ...params.inputs,
            steps: params.steps || [],
            nextButtonText: params.nextButtonText || '',
            backButtonText: params.backButtonText || '',
            finishButtonText: params.finishButtonText || '',
            hideProgressBar: params.hideProgressBar || false,
            firstProgressStep: params.firstProgressStep || 0,
            trackingId: params.trackingId || '',
        },
    };
};
